import axiosClient from './axiosClient';

const vendorService = {
    currentVendor: async () => {
        const response = await axiosClient.get('/vendor');
        console.log('Vendor Data:', response.data.data);
        return response.data.data;
    },
    updateVendor: async (vendorData) => {
        const response = await axiosClient.put('/vendor', vendorData);
        return response.data;
    },
    adminUpdateVendor: async (vendorId, vendorData) => {
        console.log('vendorData', vendorData);
        const response = await axiosClient.put(`/admin/vendors/${vendorId}`, vendorData);
        return response.data;
    },
    updateVendorBankDetails: async (bankDetails) => {
        const response = await axiosClient.put('/vendor/bank', bankDetails);
        return response.data;
    },
    adminGetVendor: async (vendorId) => {
        const response = await axiosClient.get(`/admin/vendors/${vendorId}`);
        return response.data;
    },

    updateVendorCoordinate: async (coordinates) => {
        const response = await axiosClient.put('/vendor/location', coordinates);
        return response.data;
    },

    getAllVendors: async (params) => {
        const response = await axiosClient.get('/admin/vendors/all', { params });
        return response.data;
    }
};

export default vendorService;
